import { createAction, props } from '@ngrx/store';

export const toggleMenu = createAction('[Layout Core] toggle menu');
export const displaySidebar = createAction(
  '[Layout Core] set menu',
  props<{ display: boolean }>()
);
